import React from 'react';
import { FilterContextProvider } from './FilterContext';
import { UserContextProvider } from './UserContext';
export const AppContextProvider: React.FC = ({children}) => (
	<FilterContextProvider>
		<UserContextProvider>
			{ children }
		</UserContextProvider>
	</FilterContextProvider>
);